import styled, {css, keyframes} from "styled-components";
import {Link} from "react-router-dom";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 250px;

  @media only screen and (${({theme}) => theme.media.small}) {
    height: 100%;
  }
`

export const Banner = styled.div`
  position: relative;
  color: ${({theme}) => theme.colors.white};
  margin: 0;  
  width: 100%;
`

export const Logo = styled.div`
  position: absolute;
  width: 100%;
`

export const Phone = styled.img<{show: boolean}>`
  position: relative;
  z-index: 10;
  object-fit: contain;
  width: 25%;
  height: auto;
  left: 10%;
  transition: top 2s linear, opacity 2s linear;
  
  ${({show}) => show
    ? css`
      top: 3vh;
      opacity: 1;
    `
    :
    css `
      top: -300px;
      opacity: 0;
    `
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    width: 25%;
  }

`

export const Text = styled.span<{show: boolean}>`
  position: absolute;
  z-index: 8;
  backdrop-filter: blur(8px);
  border-radius: 0 40px 40px 0;
  width: fit-content;
  height: fit-content;
  color: ${({theme}) => theme.colors.navFont};
  padding: 5px 20px;
  font-size: 14px;
  ${({show, theme}) => show
    ? css`opacity: 1; background-color: ${theme.colors.secondaryBackground};` 
    : css`opacity: 0; background-color: rgba(128, 128, 128, 0.5);`
  };

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 14px;
    padding: 0.5rem 2rem 0.5rem 3rem;
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    font-size: 16px;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    padding: 0.5rem 2rem 0.5rem 3rem;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    font-size: 20px;
    padding: 1rem 2rem 1rem 3rem;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
  }
`

export const Text1 = styled(Text)`
  transition: all 1000ms 2000ms linear;
  top: 25%;
  left: 26%;

  @media only screen and (${({theme}) => theme.media.small}) {
    top: 25%;
    left: 26%;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    top: 25%;
    left: 27%;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    top: 25%;
    left: 28%;
  }
`

export const Text2 = styled(Text)`
  transition: all 1000ms 2800ms linear;
  top: calc(27% + 2rem);
  left: 27%;

  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    top: calc(25% + 2rem);
    left: 26%;
  }
  
  @media only screen and (${({theme}) => theme.media.small}) {
    top: calc(25% + 2.5rem);
    left: 26%;
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    top: calc(25% + 2.5rem);
    left: 27%;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    top: calc(25% + 3rem);
    left: 27%;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    top: calc(25% + 4rem);
    left: 29%;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    top: calc(25% + 5rem);
    left: 29%;
  }
`

export const Text3 = styled(Text)`
  transition: all 1000ms 3400ms linear;
  top: calc(48% + 2rem);
  left: 31%;

  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    //top: calc(49% + 2rem);
    left: 26%;
  }
  
  @media only screen and (${({theme}) => theme.media.small}) {
    top: calc(25% + 5rem);
    left: 26%;
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    top: calc(25% + 5rem);
    left: 28%;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    top: calc(25% + 6rem);
    left: 28%;
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    top: calc(25% + 8rem);
    left: 30%;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    top: calc(25% + 10rem);
    left: 30%;
  }
`

export const Info = styled.div`
  display: none;
  position: absolute;
  top: 10%;
  right: 5%;
  width: 30%;
  height: fit-content;
  z-index: 20;
  background: ${({theme}) => theme.colors.thirdlyBackground};
  backdrop-filter: blur(8px);
  border-radius: 40px;
  padding: 1rem;
  color: ${({theme}) => theme.colors.secondaryFont};
  
  & h3 {
    text-transform: uppercase;
    font-size: 16px;
    line-height: 20px;
  }
  
  & p {
    font-size: 14px;
    line-height: 16px;
    margin-top: 1rem;
  }
  
  & img {
    position: relative;
    float: right;
    width: 40%;
  }
  
  & a {
    display: inline-block;
    margin-top: 1rem;
    color: ${({theme}) => theme.colors.red};
    font-size: 15px;
    line-height: 17px;
    text-transform: uppercase;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    display: block;
    padding: 40px;
    
    & h3 {
      font-size: 16px;
      line-height: 20px;
    }

    & img {
      width: 40%;
    }
    
    & p {
      font-size: 14px;
      line-height: 20px;
    }
    
    & a {
      font-size: 15px;
      line-height: 18px;
    }
  }

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    right: 15%;
    
    & h3 {
      font-size: 20px;
      line-height: 28px;
    }

    & img {
      width: 30%;
      top: -3rem;
    }

    & p {
      font-size: 18px;
      line-height: 24px;
    }

    & a {
      font-size: 22px;
      line-height: 26px;
    }
  }
`

interface DwlBlockProps {
    top: number
    fixed: boolean
}

export const DownloadBlock = styled.div.attrs<DwlBlockProps>(({top, fixed}) => {
    return {
        style: fixed
            ? {top: '20px', position: 'fixed'}
            : {top: top + 'px', position: 'relative'}
    }
})<DwlBlockProps>`
  width: 100%;
  right: 1rem;
  z-index: 21;
`

const hideBtn1 = keyframes`
  from {
    right: 14%;
    width: 250px;
    //opacity: 1;
  }
  to {
    right: 0;
    width: 0;
    //opacity: 0;
  }
`

const showBtn1 = keyframes`
  from {
    right: 0;
    width: 0;
    opacity: 0;
  }
  to {
    right: 14%;
    width: 250px;
    opacity: 1;
  }
`

interface DwlBtn1Props {
    hide: boolean,
}

/* ${({hide}) => hide
          ? css`
            animation: ${hideBtn1} 1s linear;
            pointer-events: none;
            //opacity: 0;
          `
          : css`
            animation: ${showBtn1} 1s linear;
          `
  };*/

export const DwlButton1 = styled.button.attrs<DwlBtn1Props>(({hide, theme}) => {
    return {}
    //return hide ? {style: {width: '70px', right: 0}} : {}
})<DwlBtn1Props>`
  top: 100px;
  position: absolute;
  right: 14%;
  opacity: 1;
  overflow: hidden;
  white-space: nowrap;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 12px;
  background: rgba(179, 55, 108, 0.8);
  text-shadow: 0 2px 6px rgba(179, 55, 108, 0.5);
  backdrop-filter: blur(2.5px);
  border: none;
  border-radius: 40px;
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  line-height: 14px;
  font-family: ${({theme}) => theme.font.family};
  text-transform: uppercase;
  cursor: pointer;
  transition: width .5s linear, right .5s linear;

  ${({hide}) => hide
          ? css`
            width: 70px;
            right: 0;
            &:hover {
              width: 220px; 
              background-color: rgba(179, 55, 108, 1);
            }
          `
          : null
  };

  &:hover {
    background-color: rgba(179, 55, 108, 1)
  }
  
  &:hover span {
    display: inline-block;
  }

  & span {
    display: none;
  }

  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    text-transform: uppercase;
    top: 90px;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    text-transform: none;
    top: 0;
    ${({hide}) => hide ? css`width: 70px;` : css`width: 340px;`};
    font-size: 14px;
    line-height: 18px;
    padding: 12px;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    line-height: 20px;
    padding: 18px;
  }
  
  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    font-size: 24px;
    line-height: 28px;
    padding: 20px;
  }
`

interface DwlBtn2Props {
    show: boolean
}

export const DwlButton2 = styled.button.attrs<DwlBtn2Props>(({show, theme}) => {
    return show ? {style: {opacity: 0.8}} : {}
})<DwlBtn2Props>`
  position: absolute;
  right: 0;
  width: 50px;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  padding: 10px 10px;
  background: rgb(179, 55, 108);
  backdrop-filter: blur(2.5px);
  border-radius: 40px 40px 40px 0;
  border: none;
  white-space: nowrap;
  font-size: 18px;
  font-family: ${({theme}) => theme.font.family};
  color: #ffffff;
  opacity: 0;
  transition: width 500ms linear, opacity 2s 3s linear;
  
  ${({show}) => show
          ? css`
            &:hover {
              opacity: 1 !important;
              width: 160px;
              background-color: rgba(179, 55, 108, 1)
            }
          `
          : null
  };

  &:hover span {
    display: inline-block;
  }
  
  & span {
    display: none;
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    & svg {
      width: 25px;
      height: 25px;
    }
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    padding: 15px 10px;
    width: 65px;

    & svg {
      width: 30px;
      height: 30px;
    }
  }
  
  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 15px 15px;
    width: 70px;

    & svg {
      width: 38px;
      height: 38px;
    }
  }
`

const backGroupAnimation = keyframes`
  from {
    transform: translateY(500px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

const middleGroupAnimation = keyframes`
  from {
    transform: translateY(300px);
    opacity: 0;
  } 
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

const frontGroupAnimation = keyframes`
  from {
    transform: translateY(100px);
  }
  to {
    transform: translateY(0);
  }
`

const footerAnimation = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

export const BannerBackPart = styled.svg.attrs({
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    display: 'block'
})`
  animation: ${backGroupAnimation} 1.5s linear;
`

export const BannerMiddlePart = styled.svg.attrs({
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    display: 'block'
})`
  animation: ${middleGroupAnimation} 3s 0s ease-out;
`

export const BannerFrontPart = styled.svg.attrs({
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    display: 'block'
})`
  animation: ${frontGroupAnimation} 1s linear;
`

export const FooterPart = styled.svg.attrs({
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
})`
  & path {
    transition: opacity 1s linear;
  }
`

export const Rocks = styled.svg.attrs({
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  display: 'block'
})`
  
  & #back {
    animation: ${backGroupAnimation} 1.5s linear;
  }
  
  & #middle {
    animation: ${middleGroupAnimation} 3s 0s ease-out;
  }

  & #front {
    animation: ${frontGroupAnimation} 1s linear;
  }
  
  & #footer path {
    transition: opacity 1s linear;
  }
`

export const SocialBlock = styled.div`
  display: none;
  text-align: center;
  margin-top: 5px;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: block;
  }
`

export const SocialLink = styled(Link)`
  margin: 0 5px;
  
  & svg {
    height: 20px;
    width: 20px;
  }
  
  &:hover svg g {
    opacity: 1;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    margin: 0 5px;

    & svg {
      height: 30px;
      width: 30px;
    }
  }
  
  @media only screen and (${({theme}) => theme.media.medium}) {
    margin: 0 10px;

    & svg {
      height: 40px;
      width: 40px;
    }
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    margin: 0 10px;

    & svg {
      height: 60px;
      width: 60px;
    }
  }
`